import {
  StyleSheet,
  // Platform,
} from 'react-native';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import {
  primaryFont500,
  primaryFont700,
} from './Common';

const headerHeight = 64;
const iPhoneXDelta = 20;

export default StyleSheet.create({
  main: {
    flexDirection: 'column',
    alignContent: 'center',
  },
  headless: {
    width: '100%',
    flex: 1,
    paddingTop: 60,
    backgroundColor: 'white',
    // alignContent: 'stretch',
    // alignItems: 'stretch',
    ...ifIphoneX({
      paddingBottom: 10,
    }),
  },
  headed: {
    width: '100%',
    flex: 1,
    backgroundColor: 'white',
    // alignContent: 'stretch',
    // alignItems: 'stretch',
    ...ifIphoneX({
      paddingBottom: 10,
    }),
  },
  header: {
    width: '100%',
    height: headerHeight,
  },
  headerContainer: {
    width: '100%',
    height: ifIphoneX(headerHeight + iPhoneXDelta, headerHeight),
    backgroundColor: 'white',
    flexDirection: 'row',
  },
  headerCenter: {
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
  },
  headerCenterContainer: {
    position: 'absolute',
    top: ifIphoneX(iPhoneXDelta, 0),
    width: '100%',
    height: headerHeight,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerRight: {
    fontFamily: primaryFont500,
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 17,
    margin: 20,
    color: 'black',
  },
  headerRightContainer: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: headerHeight,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  form: {
    flex: 1,
    // alignContent: 'stretch',
    // alignItems: 'stretch',
  },
});
